module.exports = __webpack_public_path__ + "img/tg.cf649278.svg";